// extracted by mini-css-extract-plugin
module.exports = {"whiteGradient":"button_whiteGradient__3SGbd","purpleGradient":"button_purpleGradient__3G1U1"};